module.exports = __webpack_public_path__ + "static/media/banner2b.ab0f1b71.svg";